// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__JB7kv","notes":"Notes_notes__1SbO4","note":"Notes_note__1i-VS","markdown":"Notes_markdown__1yGBc"};